import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import Typography from "@material-ui/core/Typography";
import { StackedBarChart, LineChart, SimpleBarChart } from "@carbon/charts-react";
import { InlineLoading, Tooltip } from 'carbon-components-react';

import i18n from "../../i18n";
import * as DashboardConstants from '../Dashboards/DashboardConstants';
import DashboardGroupedBarChart from '../Dashboards/DashboardGroupedBarChart';
import DashboardAreaChart from "../Dashboards/DashboardAreaChart";
import DashboardLineChart from "../Dashboards/DashboardLineChart";
import DashboardGaugeChart from '../Dashboards/DashboardGaugeChart';
import DashboardTable from '..//Dashboards/DashboardTable';
import TableToolbarDownload from '../../common/TableToolbarDownload';
import { IncidentAnalysis, IncidentSummary, IncidentResponseResolution, ReopenCountSLA, IncidentAgeing } from './KPI/IncidentKPI';
import {
    SuccessRate, BotSummary, QueuePerformanceData, AccuracyReportTrend, TerminationRateTrend, AutomataStartsOnTrend, AutomataRunsOnTrend, FTESaving,
    ResourceUtilization, FirstTimeRunSuccessful, OnboardAutomataCount, ExceptionClassification, TopLongRunningAutomata, SchedulerExceptionsCount, OnboardAutomataVMCount
} from './KPI/AutomataKPI';
import { IncidentVelocityTrend, AlertDistributionData, IncidentConversion } from './KPI/AlertKPI';
import { getSalesForceTrend } from './KPI/SalesforceKPI';
import { botSummaryReportTableHeaders, performanceTrendHeaders, queuePerformanceHeaders, RepeatedTerminationBotsHeaders, queueAverageHeaders } from './KPI/tableHeaders';
import DashboardDonutChart from './HomeScreenDonutChart';
import * as SalesForceConfig from '../Dashboards/SalesForceConfig';
import './HomeScreen.scss';

const useStyles = makeStyles({
    root: {
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column"
    },
    header: {
        display: "flex",
        flexDirection: "row",
        // alignItems: "center",
        padding: "0.5rem"
    },
    spacer: {
        flexGrow: 1
    },
    deleteIcon: {
        display: 'flex',
        alignItems: 'flex-start'
    },
    body: {
        padding: "0.5rem",
        flexGrow: 1
    }
});


export default function Widget({ id, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace, timeFilterSelections, preferencesChanged }) {

    const incidentAnalysis = i18n.t('homepage.incidentAnalysis');
    const responseSLA = i18n.t('homepage.responseSLA');
    const automataSuccessRate = i18n.t('homepage.automataSuccessRate');
    const incidentsSummary = i18n.t('homepage.incidentsSummary');

    const [SuccessRateLoading, setSuccessRateLoading] = useState(true);
    const [successRateData, setSuccessRateData] = useState([]);
    const [IncidentAnalysisData, setIncidentAnalysisData] = useState([]);
    const [IncidentAnalysisLoading, setIncidentAnalysisLoading] = useState(true);
    const [TotalIncidents, setTotalIncidents] = useState(0);
    const [IncidentSummaryData, setIncidentSummaryData] = useState([]);
    const [IncidentSummaryLoading, setIncidentSummaryLoading] = useState(true);
    const [IncidentResponseResolutionData, setIncidentResponseResolutionData] = useState([]);
    const [IncidentResponseResolutionLoading, setIncidentResponseResolutionLoading] = useState(true);
    const [incidentVelocityTrendLoading, setIncidentVelocityTrendLoading] = useState(true);
    const [incidentVelocityTrendData, setIncidentVelocityTrendData] = useState([]);
    const [reopenCountLoading, setReopenCountLoading] = useState(true);
    const [reopenCountSLAData, setReopenCountSLAData] = useState([]);
    const [incidentAgeingLoading, setIncidentAgeingLoading] = useState(true);
    const [incidentAgeingData, setIncidentAgeingData] = useState([]);
    const [alertDistributionDataLoading, setAlertDistributionDataLoading] = useState(true);
    const [alertDistributionData, setAlertDistributionData] = useState([]);
    const [botSummaryReportData, setBotSummaryReportData] = useState([]);
    const [botSummaryReportDataLoading, setBotSummaryReportDataLoading] = useState(false);
    const [QueuePerformanceTableLoading, setQueuePerformanceTableLoading] = useState(true);
    const [AccuracyReportTrendLoading, setAccuracyReportTrendLoading] = useState(true);
    const [performanceTrendTableData, setPerformanceTrendTableData] = useState([]);
    const [queueformanceTableData, setQueueformanceTableData] = useState([]);
    const [terminationRateTrendLoading, setTerminationRateTrendLoading] = useState(false);
    const [terminationRateTrendData, setTerminationRateTrendData] = useState([]);
    const [automataStartsdata, setAutomataStartsData] = useState([]);
    const [StartedOnTimeLoading, setStartedOnTimeLoading] = useState(false);
    const [RunsOnTimeLoading, setRunsOnTimeLoading] = useState(false);
    const [automataRunsdata, setAutomataRunsData] = useState([]);
    const [FTESavingLoading, setFTESavingLoading] = useState(false);
    const [FTESavingData, setFTESavingData] = useState(0);
    const [resourceUtilizationLoading, setResourceUtilizationLoading] = useState(false);
    const [resourceUtilizationData, setResourceUtilizationData] = useState(0);
    const [incidentConversionLoading, setincidentConversionLoading] = useState(false);
    const [incidentConversionData, setIncidentConversionData] = useState([]);
    const [noiseReduction, setNoiseReduction] = useState();
    const [alertClassificationLoading, setAlertClassificationLoading] = useState(false);
    const [alertClassificationData, setAlertClassificationData] = useState({});
    const [informationalAlerts, setInformationalAlerts] = useState();
    const [barChartLoading, setBarChartLoading] = useState(false);
    const [firstTimeBarData, setFirstTimeBarData] = useState([]);
    const [OnboardAutomataLoading, setOnboardAutomataLoading] = useState(false);
    const [OnboardAutomataData, setOnboardAutomataData] = useState(0);
    const [executionClassificationsData, setExecutionClassificationsData] = useState([]);
    const [executionClassificationsLoading, setExecutionClassificationsLoading] = useState(false);
    const [LongRunningAutomataData, setLongRunningAutomataData] = useState([]);
    const [SchedulerExceptionLoading, setSchedulerExceptionLoading] = useState(true);
    const [RepeatedTerminationTableLoading, setRepeatedTerminationTableLoading] = useState(false);
    const [RepeatedTerminationBots, setRepeatedTerminationBots] = useState([]);
    const [SchedulerExceptionCountLoading, setSchedulerExceptionCountLoading] = useState(false);
    const [SchedulerExceptionCount, setSchedulerExceptionCount] = useState([]);
    const [QueueAverageLoading, setQueueAverageLoading] = useState(true);
    const [QueueAverageData, setQueueAverageData] = useState([]);
    const [longRunningSummaryData, setLongRunningSummaryData] = useState(0);
    const [OnboardAutomataVMLoading, setOnboardAutomataVMLoading] = useState(false);
    const [OnboardAutomataVMData, setOnboardAutomataVMData] = useState(0);
    const [LoginTrendLoading, setLoginTrendLoading] = useState(false);
    const [LoginTrendData, setLoginTrendData] = useState([]);
    const [UserLoginTopFailuresLoading, setUserLoginTopFailuresLoading] = useState(false);
    const [UserLoginTopFailuresData, setUserLoginTopFailuresData] = useState([]);
    const [BatchJobsTrendLoading, setBatchJobsTrendLoading] = useState(false);
    const [BatchJobsTrendData, setBatchJobsTrendData] = useState([]);
    const [BatchJobsTopFailuresLoading, setBatchJobsTopFailuresLoading] = useState(false);
    const [BatchJobsTopFailuresData, setBatchJobsTopFailuresData] = useState([]);
    const [IntegrationTrendLoading, setIntegrationTrendLoading] = useState(false);
    const [IntegrationTrendData, setIntegrationTrendData] = useState([]);
    const [IntegrationTopFailuresLoading, setIntegrationTopFailuresLoading] = useState(false);
    const [IntegrationTopFailuresData, setIntegrationTopFailuresData] = useState([]);
    const [AbandonedProcessesTrendLoading, setAbandonedProcessesTrendLoading] = useState(false);
    const [AbandonedProcessesTrendData, setAbandonedProcessesTrendData] = useState([]);
    const [AbandonedProcessesTopFailuresLoading, setAbandonedProcessesTopFailuresLoading] = useState(false);
    const [AbandonedProcessesTopFailuresData, setAbandonedProcessesTopFailuresData] = useState([]);

    useEffect(() => {
        if ((timeFilterSelections && timeFilterSelections.startDateTime && timeFilterSelections.endDateTime) || preferencesChanged) {
            switch (id) {
                case 'IncidentAnalysis':
                    getIncidentAnalysis(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
                    break;
                case 'IncidentSummary':
                    getIncidentSummary(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
                    break;
                case 'SuccessRate':
                    getSuccessRate(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
                    break;
                case 'FirtsTimeResolution':
                    getReopenCountSLA(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
                    break;
                case 'IncidentAgeing':
                    getIncidentAgeing(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
                    break;
                case 'ResponseAndResolutionSLAMet':
                    getIncidentResponseResolution(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
                    break;
                case 'AlertVsIncidentTrend':
                    getIncidentVelocityTrend(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
                    break;
                case 'IcrAndNoiseReduction':
                    getIncidentConversionRatio(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
                    break;
                case 'AlertClassification':
                    getAlertClassification(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
                    break;
                case 'AlertDistribution':
                    getAlertDistributionData(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
                    break;
                case 'SuccessTerminationTrend':
                    getTerminationRateTrend(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
                    break;
                case 'ResourceLiveStatus':
                    //getIncidentConversionRatio(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
                    break;
                case 'SelfHeal':
                    //getAlertClassification(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
                    break;
                case 'ProductivityMetrics':
                    getFTESaving(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
                    getResourceUtilization(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
                    getOnboardAutomataCount(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
                    getOnboardAutomataVMCount(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
                    break;
                case 'QueueStatistics':
                    getAccuracyReportTrend(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
                    break;
                case 'QueuePerformance':
                    getQueuePerformanceData(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
                    break;
                case 'LongRunningAutomataList':
                    getLongRunningAutomatas(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
                    break;
                case 'FirstTimeSuccessfulRun':
                    getFirstTimeRun(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
                    break;
                case 'ExceptionClassification':
                    getExceptionClassification(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
                    break;
                // case 'TerminationReasons':
                //     getTopTerminationReasons(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
                //     break;
                case 'SchedulingEfficiency':
                    getLongRunningAutomatas(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
                    getSchedulerExceptionCount(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
                    break;
                case 'QueueAverage':
                    //getQueuePerformanceData(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
                    getQueueAverage(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
                    break;
                case 'AutomataStartsOnTimeTrend':
                    getAutomataStartsOnTime(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
                    break;
                case 'AutomataRunsOnTimeTrend':
                    getAutomataRunsOnTime(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
                    break;
                case 'BotSummaryReport':
                    getBotSummary(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
                    break;
                case 'LoginTrend':
                    getLoginTrend(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace, SalesForceConfig.Login);
                    break;
                case 'UserLoginTopFailures':
                    getUserLoginTopFailures(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace, SalesForceConfig.Login);
                    break;
                case 'BatchJobsTrend':
                    getBatchJobsTrend(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace, SalesForceConfig.BatchJobs);
                    break;
                case 'BatchJobsTopFailures':
                    getBatchJobsTopFailures(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace, SalesForceConfig.BatchJobs);
                    break;
                case 'IntegrationTrend':
                    getIntegrationTrend(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace, SalesForceConfig.Integrations);
                    break;
                case 'IntegrationTopFailures':
                    getIntegrationTopFailures(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace, SalesForceConfig.Integrations);
                    break;
                case 'AbandonedProcessesTrend':
                    getAbandonedProcessesTrend(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace, SalesForceConfig.AbandonedProcess);
                    break;
                case 'AbandonedTopFailures':
                    getAbandonedProcessesTopFailures(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace, SalesForceConfig.AbandonedProcess);
                    break;
                default: break;
            }
        }
    }, [preferencesChanged, id]);

    let successChartTitle = `<div style="display:flex; justify-content: space-between; flex-direction: row">
    <div style="font-size: 20px;font-weight: 600;line-height: 22px;font-family: "IBM Plex Sans";"></div>
    <div style="font-family: IBM Plex Sans Light; font-size : 16px;">${DashboardConstants.CriticalTargetPercentage}</div>
    </div> ` ;

    const SalesforceLineChartColors = {
        'total': "#0f62fe",
        'failure': "#da1e28",
        'successful': "#198038",
        'Total': "#0f62fe",
        'Failure': "#da1e28",
        'Successful': "#198038"
    };

    const colors = {
        "New": "#82CFFF", //cyan30 
        "On Hold": "#003A6D", //cyan80
        "Resolved": "#33B1FF", //cyan40
        "In Queue": "#BAE6FF", //cyan20
        "Assigned": "#08BDBA", //teal40
        "Rejected": "#3DDBD9", //$teal30
        "Closed": "#0072C3", //$cyan60 
        "Cancelled": "#007d79", //$teal60
        "Canceled": "#005d5d", //$teal70
        "Work In Progress": "#009d9a", //$teal50
        "Pending": "#00539a", //$cyan70 
        "In Progress": "#9EF0F0", //$teal20 
        "Open": "#012749" //$cyan90 
    };

    const lineChartColors = {
        "Response": "#00539A",
        "Resolution": "#1192E8",
    };

    const getCustomTooltip = (data) => {
        let total = 0;
        let list = data.map((val) => {
            const { group, value } = val;
            total = total + parseFloat(value);
            return `<li><div class="datapoint-tooltip">
                        <div class="tooltip-color tooltip-14-1-1"></div>
                        <div style="background-color: ${colors[group]}" class="tooltip-color"></div>
                        <div class="label"><p>${group}</p></div>
                        <p class="value"/>${value}</p>
                    </div>
                    </li>`
        }).join('');

        let totalList = `<li> <div class="datapoint-tooltip bold">				
        <div class="label">
        <p>Total</p>
        </div>
        <p class="value">${total}</p></div></li>`;

        let tooltip = `<ul class='multi-tooltip'>${list}${data.length > 1 ? totalList : ''}</ul>`;
        return tooltip;
    }

    let barchartOptions = {
        "title": `<div style="display:flex; gap:5px; flex-direction:column">
                  <div style="font-family: IBM Plex Sans Light; font-size : 16px; ">${DashboardConstants.Total} ${TotalIncidents}</div>
                  </div> ` ,
        color: {
            "gradient": {
                "enabled": true
            },
            scale: colors
        },
        "legend": {
            "enabled": true
        },
        "axes": {
            "left": {
                "mapsTo": "value"
            },
            "bottom": {
                "mapsTo": "group",
                "scaleType": "labels",
                ticks: {
                    values: []
                }
            }
        },
        "height": "300px",
        "data": { loading: IncidentAnalysisLoading },
        'tooltip': {
            customHTML: (data, defaultHTML) => getCustomTooltip(data)
        }
    }

    let stackedBarChartOptions = {
        "axes": {
            "left": {
                "scaleType": "labels"
            },
            "bottom": {
                "stacked": true
            }
        },
        datasetLabel: {
            label: 'Hello'
        },
        pie: {
            labels: {
                enabled: false
            }
        },
        color: {
            scale: colors
        },
        "data": { loading: IncidentSummaryLoading },
        "height": "300px",
        'tooltip': {
            customHTML: (data, defaultHTML) => getCustomTooltip(data),
            showTotal: true
        }
    }

    let AlertlineChartOptions = {
        "axes": {
            "bottom": {
                "title": DashboardConstants.Time,
                "mapsTo": "date",
                "scaleType": "labels"
            },
            "left": {
                "mapsTo": "value",
                "scaleType": "linear",
            }
        },
        "curve": "curveMonotoneX",
        "legend": {
            "orientation": "horizontal",
            "alignment": "left"
        },
        "data": { loading: incidentVelocityTrendLoading },
        "height": "300px",
        color: {
            scale: lineChartColors
        },
        'tooltip': {
            customHTML: (data, defaultHTML) => getCustomTooltip(data),
            showTotal: true
        }
    }

    let lineChartOptions = {
        "axes": {
            "bottom": {
                "title": DashboardConstants.Time,
                "mapsTo": "date",
                "scaleType": "labels"
            },
            "left": {
                "mapsTo": "value",
                "scaleType": "linear",
            }
        },
        "curve": "curveMonotoneX",
        "legend": {
            "orientation": "horizontal",
            "alignment": "left"
        },
        "data": { loading: IncidentResponseResolutionLoading },
        "height": "300px",
        color: {
            scale: lineChartColors
        },
        'tooltip': {
            customHTML: (data, defaultHTML) => getCustomTooltip(data),
            showTotal: true
        }
    }

    const options = {
        "title": "",
        "axes": {
            "left": {
                "mapsTo": "value"
            },
            "bottom": {
                "mapsTo": "group",
                "scaleType": "labels"
            }
        },
        "height": "300px",
        "modalTitle": "",
        color: {
            scale: colors
        },
    }

    const getSuccessRate = async (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace) => {
        setSuccessRateLoading(true);
        const successRateValue = await SuccessRate(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
        setSuccessRateData(successRateValue.data);
        setSuccessRateLoading(successRateValue.loader);
    }

    const getIncidentAnalysis = async (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace) => {

        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            setIncidentAnalysisLoading(true);

            const incidentAnalysisValue = await IncidentAnalysis(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
            setIncidentAnalysisData(incidentAnalysisValue.data);
            setIncidentAnalysisLoading(incidentAnalysisValue.loader);
            setTotalIncidents(incidentAnalysisValue.total);
        }
    }

    const getIncidentSummary = async (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace) => {
        setIncidentSummaryLoading(true);
        const incidentSummaryValue = await IncidentSummary(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace)
        setIncidentSummaryData(incidentSummaryValue.data);
        setIncidentSummaryLoading(incidentSummaryValue.loader);
    }

    const getIncidentResponseResolution = async (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace) => {
        setIncidentResponseResolutionLoading(true);

        const incidentResponseValue = await IncidentResponseResolution(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace)
        setIncidentResponseResolutionData(incidentResponseValue.data);
        setIncidentResponseResolutionLoading(incidentResponseValue.loader);
    }

    const getIncidentVelocityTrend = async (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace) => {
        setIncidentVelocityTrendLoading(true);

        const incidentVelocityTrendValue = await IncidentVelocityTrend(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace)
        setIncidentVelocityTrendData(incidentVelocityTrendValue.data);
        setIncidentVelocityTrendLoading(incidentVelocityTrendValue.loader);
    }

    const getAlertDistributionData = async (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace) => {
        setAlertDistributionDataLoading(true);

        const alertDistributionDataValue = await AlertDistributionData(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace)
        setAlertDistributionData(alertDistributionDataValue.data);
        setAlertDistributionDataLoading(alertDistributionDataValue.loader);
    }

    const getReopenCountSLA = async (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace) => {
        setReopenCountLoading(true);

        const reopenCountSLAValue = await ReopenCountSLA(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
        setReopenCountSLAData(reopenCountSLAValue.data);
        setReopenCountLoading(reopenCountSLAValue.loader);
    }

    const getIncidentAgeing = async (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace) => {
        setIncidentAgeingLoading(true);

        const IncidentAgeingValue = await IncidentAgeing(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
        setIncidentAgeingData(IncidentAgeingValue.data);
        setIncidentAgeingLoading(IncidentAgeingValue.loader);
    }

    const getBotSummary = async (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace) => {
        setBotSummaryReportDataLoading(true);

        const BotSummaryValue = await BotSummary(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
        setBotSummaryReportData(BotSummaryValue.data);
        setBotSummaryReportDataLoading(BotSummaryValue.loader);
    }

    const getAccuracyReportTrend = async (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace) => {
        setAccuracyReportTrendLoading(true);

        const AccuracyReportTrendValue = await AccuracyReportTrend(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
        setPerformanceTrendTableData(AccuracyReportTrendValue.data);
        setAccuracyReportTrendLoading(AccuracyReportTrendValue.loader);
    }

    const getQueuePerformanceData = async (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace) => {
        setQueuePerformanceTableLoading(true);

        const QueuePerformanceDataValue = await QueuePerformanceData(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
        setQueueformanceTableData(QueuePerformanceDataValue.data);
        setQueuePerformanceTableLoading(QueuePerformanceDataValue.loader);
    }

    const getTerminationRateTrend = async (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace) => {
        setTerminationRateTrendLoading(true);

        const terminationRateTrendValue = await TerminationRateTrend(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
        setTerminationRateTrendData(terminationRateTrendValue.data);
        setTerminationRateTrendLoading(terminationRateTrendValue.loader);
    }

    const getAutomataStartsOnTime = async (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace) => {
        setStartedOnTimeLoading(true);

        const automataStartsOnTimeValue = await AutomataStartsOnTrend(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
        setAutomataStartsData(automataStartsOnTimeValue.data);
        setStartedOnTimeLoading(automataStartsOnTimeValue.loader);
    }

    const getAutomataRunsOnTime = async (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace) => {
        setStartedOnTimeLoading(true);

        const automataRunsOnTimeValue = await AutomataRunsOnTrend(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
        setAutomataRunsData(automataRunsOnTimeValue.data);
        setRunsOnTimeLoading(automataRunsOnTimeValue.loader);
    }

    const getFTESaving = async (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace) => {
        setFTESavingLoading(true);

        const FTESavingValue = await FTESaving(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
        setFTESavingData(FTESavingValue.data);
        setFTESavingLoading(FTESavingValue.loader);
    }

    const getResourceUtilization = async (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace) => {
        setResourceUtilizationLoading(true);

        const resourceUtilValue = await ResourceUtilization(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
        setResourceUtilizationData(resourceUtilValue.data);
        setResourceUtilizationLoading(resourceUtilValue.loader);
    }

    const getIncidentConversionRatio = async (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace) => {
        setincidentConversionLoading(true);

        const incidentConversionValue = await IncidentConversion(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
        setIncidentConversionData(incidentConversionValue.data1);
        setNoiseReduction(incidentConversionValue.data2);
        setincidentConversionLoading(incidentConversionValue.loader);
    }

    const getAlertClassification = async (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace) => {
        setAlertClassificationLoading(true);

        const alertClassificationValue = await IncidentConversion(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
        setAlertClassificationData(alertClassificationValue.data3);
        setInformationalAlerts(alertClassificationValue.data4);
        setAlertClassificationLoading(alertClassificationValue.loader);
    }

    const getFirstTimeRun = async (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace) => {
        setBarChartLoading(true);

        const firstTimeRunValue = await FirstTimeRunSuccessful(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
        setFirstTimeBarData(firstTimeRunValue.data);
        setBarChartLoading(firstTimeRunValue.loader);
    }

    const getOnboardAutomataCount = async (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace) => {
        setOnboardAutomataLoading(true);

        const OnboardAutomataValue = await OnboardAutomataCount(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
        setOnboardAutomataData(OnboardAutomataValue.data);
        setOnboardAutomataLoading(OnboardAutomataValue.loader);
    }

    const getExceptionClassification = async (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace) => {
        setExecutionClassificationsLoading(true);

        const ExceptionClassificationValue = await ExceptionClassification(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
        setExecutionClassificationsData(ExceptionClassificationValue.data);
        setExecutionClassificationsLoading(ExceptionClassificationValue.loader);
    }

    const getLongRunningAutomatas = async (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace) => {
        setSchedulerExceptionLoading(true);

        const LongRunningAutomataValue = await TopLongRunningAutomata(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
        setLongRunningAutomataData(LongRunningAutomataValue.data1);
        setLongRunningSummaryData(LongRunningAutomataValue.data2)
        setSchedulerExceptionLoading(LongRunningAutomataValue.loader);
    }

    // const getTopTerminationReasons = async (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace) => {
    //     setRepeatedTerminationTableLoading(true);

    //     const TerminationReasonsValue = await TopTerminationReasons(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
    //     setRepeatedTerminationBots(TerminationReasonsValue.data);
    //     setRepeatedTerminationTableLoading(TerminationReasonsValue.loader);
    // }

    const getSchedulerExceptionCount = async (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace) => {
        setSchedulerExceptionCountLoading(true);

        const SchedulerExceptionCountValue = await SchedulerExceptionsCount(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
        setSchedulerExceptionCount(SchedulerExceptionCountValue.data);
        setSchedulerExceptionCountLoading(SchedulerExceptionCountValue.loader);
    }

    const getQueueAverage = async (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace) => {
        setQueueAverageLoading(true);

        const QueueAverageDataValue = await QueuePerformanceData(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
        setQueueAverageData(QueueAverageDataValue.data);
        setQueueAverageLoading(QueueAverageDataValue.loader);
    }

    const getOnboardAutomataVMCount = async (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace) => {
        setOnboardAutomataVMLoading(true);

        const OnboardAutomataVMValue = await OnboardAutomataVMCount(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
        setOnboardAutomataVMData(OnboardAutomataVMValue.data);
        setOnboardAutomataVMLoading(OnboardAutomataVMValue.loader);
    }

    const getLoginTrend = async (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace, entity) => {
        setLoginTrendLoading(true);

        const LoginTrendValue = await getSalesForceTrend(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace, entity);
        setLoginTrendData(LoginTrendValue.lineChartData);
        setLoginTrendLoading(LoginTrendValue.loader);
    }

    const getUserLoginTopFailures = async (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace, entity) => {
        setUserLoginTopFailuresLoading(true);

        const UserLoginTopFailuresValue = await getSalesForceTrend(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace, entity);
        setUserLoginTopFailuresData(UserLoginTopFailuresValue.barChartData);
        setUserLoginTopFailuresLoading(UserLoginTopFailuresValue.loader);
    }

    const getBatchJobsTrend = async (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace, entity) => {
        setBatchJobsTrendLoading(true);

        const BatchJobTrendValue = await getSalesForceTrend(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace, entity);
        setBatchJobsTrendData(BatchJobTrendValue.lineChartData);
        setBatchJobsTrendLoading(BatchJobTrendValue.loader);
    }

    const getBatchJobsTopFailures = async (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace, entity) => {
        setBatchJobsTopFailuresLoading(true);

        const BatchJobsTopFailuresValue = await getSalesForceTrend(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace, entity);
        setBatchJobsTopFailuresData(BatchJobsTopFailuresValue.barChartData);
        setBatchJobsTopFailuresLoading(BatchJobsTopFailuresValue.loader);
    }

    const getIntegrationTrend = async (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace, entity) => {
        setIntegrationTrendLoading(true);

        const IntegrationTrendValue = await getSalesForceTrend(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace, entity);
        setIntegrationTrendData(IntegrationTrendValue.lineChartData);
        setIntegrationTrendLoading(IntegrationTrendValue.loader);
    }

    const getIntegrationTopFailures = async (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace, entity) => {
        setIntegrationTopFailuresLoading(true);

        const IntegrationTopFailuresValue = await getSalesForceTrend(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace, entity);
        setIntegrationTopFailuresData(IntegrationTopFailuresValue.barChartData);
        setIntegrationTopFailuresLoading(IntegrationTopFailuresValue.loader);
    }

    const getAbandonedProcessesTrend = async (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace, entity) => {
        setAbandonedProcessesTrendLoading(true);

        const AbandonedProcessesTrendData = await getSalesForceTrend(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace, entity);
        setAbandonedProcessesTrendData(AbandonedProcessesTrendData.lineChartData);
        setAbandonedProcessesTrendLoading(AbandonedProcessesTrendData.loader);
    }

    const getAbandonedProcessesTopFailures = async (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace, entity) => {
        setAbandonedProcessesTopFailuresLoading(true);

        const AbandonedProcessesTopFailuresData = await getSalesForceTrend(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace, entity);
        setAbandonedProcessesTopFailuresData(AbandonedProcessesTopFailuresData.barChartData);
        setAbandonedProcessesTopFailuresLoading(AbandonedProcessesTopFailuresData.loader);
    }


    const widgetNames = {
        IncidentAnalysis:
            <div>
                <div className="KPI-title">
                    {incidentAnalysis}
                </div>
                {IncidentAnalysisLoading === true ? <div className="loading-container"> <InlineLoading description={DashboardConstants.loading} /> </div> :
                    <div className="chart-wrapper">
                        <div className="chart-container">
                            {!IncidentAnalysisLoading && (!IncidentAnalysisData || !IncidentAnalysisData.length) ?
                                <div>{DashboardConstants.NoDataAvailable}</div>
                                :
                                <div className="simple-barChart"><SimpleBarChart data={IncidentAnalysisData} options={barchartOptions} /></div>
                            }
                        </div>
                    </div>
                }
            </div >,
        IncidentSummary: <div>
            <div className="KPI-title">
                {incidentsSummary}
            </div>
            {IncidentSummaryLoading === true ? <div className="loading-container"> <InlineLoading description={DashboardConstants.loading} /> </div> :
                <div className="chart-wrapper">
                    <div className="chart-container">
                        {!IncidentSummaryLoading && (!IncidentSummaryData || !IncidentSummaryData.length) ?
                            <div>{DashboardConstants.NoDataAvailable}</div>
                            :
                            <div className="stacked-barChart">
                                <StackedBarChart
                                    data={IncidentSummaryData}
                                    options={stackedBarChartOptions}>
                                </StackedBarChart>
                            </div>
                        }
                    </div>
                </div>}
        </div>,
        FirtsTimeResolution: <div>
            <div className="KPI-title">
                {DashboardConstants.FirstTimeResolution}
            </div>
            {reopenCountLoading === true ? <div className="loading-container"> <InlineLoading description={DashboardConstants.loading} /> </div> :
                <div className="chart-wrapper">
                    <div className="chart-container">
                        <DashboardGroupedBarChart
                            loading={reopenCountLoading}
                            graphAxesTitle={DashboardConstants.AvgIncidentAgeingResolvedTickets}
                            graphBottomTitle={DashboardConstants.Franchise}
                            groupedBarChartData={reopenCountSLAData}
                            isPercentage={true}
                            hideDownloadButton={true}
                            height="300px"
                            toolbarEnabled={false}
                        />
                    </div>
                </div>}
        </div>,
        IncidentAgeing: <div>
            <div className="KPI-title">
                {DashboardConstants.IncidentAgeingSLAReport}
            </div>
            {incidentAgeingLoading === true ? <div className="loading-container"> <InlineLoading description={DashboardConstants.loading} /> </div> :
                <div className="chart-wrapper">
                    <div className="chart-container">
                        <DashboardGroupedBarChart
                            loading={incidentAgeingLoading}
                            groupedBarChartData={incidentAgeingData}
                            graphAxesTitle={DashboardConstants.AvgIncidentAgeing}
                            graphBottomTitle={DashboardConstants.Franchise}
                            isPercentage={true}
                            hideDownloadButton={true}
                            height="300px"
                            toolbarEnabled={false}
                        />
                    </div>
                </div>}
        </div>,
        ResponseAndResolutionSLAMet: <div>
            <div className="KPI-title" >
                {responseSLA}
            </div>
            {IncidentResponseResolutionLoading === true ? <div className="loading-container"> <InlineLoading description={DashboardConstants.loading} /> </div> :
                <div className="chart-wrapper">
                    <div className="chart-container">
                        {!IncidentResponseResolutionLoading && (!IncidentResponseResolutionData || !IncidentResponseResolutionData.length) ?
                            <div>{DashboardConstants.NoDataAvailable}</div>
                            :
                            <div className="line-Chart"><LineChart data={IncidentResponseResolutionData} options={lineChartOptions} /></div>
                        }
                    </div>
                </div>}
        </div>,
        SuccessRate:
            <div>
                <div className="KPI-title">{automataSuccessRate}</div>
                {SuccessRateLoading === true ? <div className="loading-container"> <InlineLoading description={DashboardConstants.loading} /> </div> :
                    <div className="chart-wrapper">
                        <div className="chart-container">
                            <DashboardGaugeChart loading={SuccessRateLoading} gaugeChartData={successRateData} color="#1192e8" isType="full" isPercentage={true} height="300px" title={!SuccessRateLoading && (!successRateData || !successRateData.length) ? '' : successChartTitle} />
                        </div>
                    </div>}
            </div>,
        AlertVsIncidentTrend: <div>
            <div className="KPI-title" >
                {DashboardConstants.IncidentVelocityTrend}
            </div>
            {incidentVelocityTrendLoading === true ? <div className="loading-container"> <InlineLoading description={DashboardConstants.loading} /> </div> :
                incidentVelocityTrendData.length > 0 ?
                    <div className="chart-wrapper">
                        <div className="chart-container">
                            <DashboardLineChart hideDownloadButton={true} height="300px" lineGraphData={incidentVelocityTrendData} loading={incidentVelocityTrendLoading} graphTitle={DashboardConstants.Count} modalTitle="" />
                        </div>
                    </div> : DashboardConstants.NoDataAvailable}
        </div>,
        AlertDistribution:
            <div>
                <div className="KPI-title" >
                    {DashboardConstants.AlertDistribution}
                </div>
                {alertDistributionDataLoading === true ? <div className="loading-container"> <InlineLoading description={DashboardConstants.loading} /> </div> :
                    <div className="chart-wrapper">
                        <div className="chart-container">
                            <DashboardAreaChart hideDownloadButton={true} areaGraphData={alertDistributionData} loading={alertDistributionDataLoading}
                                graphTitle={DashboardConstants.Count} graphBottomTitle={DashboardConstants.Count} modalTitle="" height="300px"
                            />
                        </div>
                    </div>}
            </div>,
        BotSummaryReport: <div>
            <div className="KPI-title carbon-display-Regular-20">
                <div>{DashboardConstants.BotSummaryReport}</div>
                {/* <div className="download-button">
                    <TableToolbarDownload iconDescription={DashboardConstants.Export} rows={botSummaryReportData} headers={botSummaryReportTableHeaders} title={DashboardConstants.BotSummaryReport} filename={DashboardConstants.BotSummaryReportFileName} label={DashboardConstants.Download} />
                </div> */}
            </div>
            {botSummaryReportDataLoading === true ? <div className="loading-container"> <InlineLoading description={DashboardConstants.loading} /> </div> :
                <div className="chart-container">
                    <DashboardTable loading={botSummaryReportDataLoading} rows={botSummaryReportData}
                        headers={botSummaryReportTableHeaders} showPagination={true} isSortingAllowed={true}
                    />
                </div>}
        </div>,
        QueueStatistics:
            <div>
                <div className="KPI-title carbon-display-Regular-20">
                    <div>{DashboardConstants.AutomataAccuracyReport}</div>
                    {/* <div className="download-button">
                    <TableToolbarDownload iconDescription={DashboardConstants.Export} rows={performanceTrendTableData} headers={performanceTrendHeaders} title={DashboardConstants.AutomataAccuracyReport} filename={DashboardConstants.AutomataAccuracyReport} label={DashboardConstants.Download} />
                </div> */}
                </div>
                {AccuracyReportTrendLoading === true ? <div className="loading-container"> <InlineLoading description={DashboardConstants.loading} /> </div> :
                    <div className="chart-container">
                        <DashboardTable loading={AccuracyReportTrendLoading} rows={performanceTrendTableData} headers={performanceTrendHeaders}
                            showPagination={true} isSortingAllowed={true} />
                    </div>}
            </div>,
        QueuePerformance: <div>
            <div className="KPI-title carbon-display-Regular-20">
                <div>{DashboardConstants.QueuePerformance}</div>
                {/* <div className="download-button">
                    <TableToolbarDownload iconDescription={DashboardConstants.Export} rows={queueformanceTableData} headers={queuePerformanceHeaders} title={DashboardConstants.QueuePerformance} filename={DashboardConstants.QueuePerformance} label={DashboardConstants.Download} />
                </div> */}
            </div>
            {QueuePerformanceTableLoading === true ? <div className="loading-container"> <InlineLoading description={DashboardConstants.loading} /> </div> :
                <div className="chart-container">
                    <DashboardTable loading={QueuePerformanceTableLoading} rows={queueformanceTableData} headers={queuePerformanceHeaders}
                        showPagination={true} isSortingAllowed={true} />
                </div>}
        </div>,
        SuccessTerminationTrend:
            <div>
                <div className="KPI-title" >
                    {DashboardConstants.TerminationRateTrend}
                </div>
                {terminationRateTrendLoading === true ? <div className="loading-container"> <InlineLoading description={DashboardConstants.loading} /> </div> :
                    <div className="chart-wrapper">
                        <div className="chart-container">
                            <DashboardLineChart
                                lineGraphData={terminationRateTrendData}
                                loading={terminationRateTrendLoading}
                                graphTitle={DashboardConstants.TerminationRatepercent}
                                isPercentage={true} hideDownloadButton={true} height="300px"
                            />
                        </div>
                    </div>}
            </div>,
        AutomataStartsOnTimeTrend:
            <div>
                <div className="KPI-title">{DashboardConstants.AutomataStartsOnTime}</div>
                {StartedOnTimeLoading === true ? <div className="loading-container"> <InlineLoading description={DashboardConstants.loading} /> </div> :
                    <div className="chart-wrapper">
                        <div className="chart-container">
                            <DashboardGaugeChart loading={StartedOnTimeLoading} gaugeChartData={automataStartsdata} color="#1192e8" isType="full" isPercentage={true} height="300px" title={!StartedOnTimeLoading && (!automataStartsdata || automataStartsdata.length === 0) ? '' : successChartTitle} />
                        </div>
                    </div>}
            </div>,
        AutomataRunsOnTimeTrend:
            <div>
                <div className="KPI-title">{DashboardConstants.AutomataRunsOnTime}</div>
                {RunsOnTimeLoading === true ? <div className="loading-container"> <InlineLoading description={DashboardConstants.loading} /> </div> :
                    <div className="chart-wrapper">
                        <div className="chart-container">
                            <DashboardGaugeChart loading={RunsOnTimeLoading} gaugeChartData={automataRunsdata} color="#1192e8" isType="full" isPercentage={true} height="300px" title={!StartedOnTimeLoading && (!automataStartsdata || automataStartsdata.length === 0) ? '' : successChartTitle} />
                        </div>
                    </div>}
            </div>,
        ProductivityMetrics:
            <div>
                <div className="KPI-title">{DashboardConstants.ProductivityMetrics}</div>
                <div className="chart-wrapper" style={{ paddingBottom: '10px' }}>
                    <div className="chart-container">
                        <div className="bx--row">
                            <div className="bx--col-lg-8 bx--col-md-4" >
                                {FTESavingLoading === true ? <div className="loading-container"> <InlineLoading description={DashboardConstants.loading} /> </div> :
                                    <div style={{ borderRight: '1px solid #00539a', marginBottom: '20px' }}>
                                        <div className="card-title carbon-display-Regular-12">{DashboardConstants.FTESaving}</div>
                                        <div className="card-body">{!FTESavingLoading ? FTESavingData : DashboardConstants.NoDataAvailable}</div>
                                    </div>}
                                {resourceUtilizationLoading === true ? <div className="loading-container"> <InlineLoading description={DashboardConstants.loading} /> </div> :
                                    <div style={{ borderRight: '1px solid #00539a' }}>
                                        <div className="card-title carbon-display-Regular-12">{DashboardConstants.ResourceUtilization}</div>
                                        <div className="card-body">{!resourceUtilizationLoading ? resourceUtilizationData : DashboardConstants.NoDataAvailable}</div>
                                    </div>}
                            </div>
                            <div className="bx--col-lg-8 bx--col-md-4">
                                {OnboardAutomataLoading === true ? <div className="loading-container"> <InlineLoading description={DashboardConstants.loading} /> </div> :
                                    <div style={{ marginBottom: '20px' }}>
                                        <div className="card-title carbon-display-Regular-12">{DashboardConstants.NoOfOnboardedAutomata}</div>
                                        <div className="card-body">{!OnboardAutomataLoading ? OnboardAutomataData : DashboardConstants.NoDataAvailable}</div>
                                    </div>}
                                {OnboardAutomataVMLoading === true ? <div className="loading-container"> <InlineLoading description={DashboardConstants.loading} /> </div> :
                                    <div>
                                        <div className="card-title carbon-display-Regular-12">{DashboardConstants.NumberOfResources}</div>
                                        <div className="card-body">{!OnboardAutomataVMLoading ? OnboardAutomataVMData : DashboardConstants.NoDataAvailable}</div>
                                    </div>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>,
        IcrAndNoiseReduction:
            <div>
                <div className="KPI-title">{DashboardConstants.IncidentConversionRatio} and {DashboardConstants.EliminatedNoise}</div>
                {incidentConversionLoading === true ? <div className="loading-container"> <InlineLoading description={DashboardConstants.loading} /> </div> :
                    incidentConversionData.length > 0 && noiseReduction.length > 0 ?
                        <div className="chart-wrapper">
                            <div className="chart-container" style={{ marginTop: '20px' }}>
                                <div className="bx--row">
                                    <div className="bx--col-lg-8 bx--col-md-4">
                                        <div style={{ borderRight: '1px solid #00539a', marginBottom: '20px' }}>
                                            <div className="card-title carbon-display-Regular-12">{DashboardConstants.IncidentConversionRatioKpi}</div>
                                            <div className="card-body">{!incidentConversionLoading ? incidentConversionData : DashboardConstants.NoDataAvailable}</div>
                                        </div>
                                    </div>
                                    <div className="bx--col-lg-8 bx--col-md-4">
                                        <div style={{ marginBottom: '20px' }}>
                                            <div className="card-title carbon-display-Regular-12">{DashboardConstants.EliminatedNoiseKpi}</div>
                                            <div className="card-body">{!incidentConversionLoading ? noiseReduction : DashboardConstants.NoDataAvailable}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> : DashboardConstants.NoDataAvailable}
            </div>,
        AlertClassification:
            <div>
                <div className="KPI-title">{DashboardConstants.AlertClassification}</div>
                {alertClassificationLoading === true ? <div className="loading-container"> <InlineLoading description={DashboardConstants.loading} /> </div> :
                    Object.keys(alertClassificationData).length > 0 ?
                        <div className="chart-wrapper" style={{ paddingBottom: '10px' }}>
                            <div className="chart-container">
                                <div className="bx--row">
                                    <div className="bx--col-lg-8 bx--col-md-4">
                                        <div style={{ borderRight: '1px solid #00539a', marginBottom: '20px' }}>
                                            <div className="card-title carbon-display-Regular-12">{DashboardConstants.TotalAlertsCount}</div>
                                            <div className="card-body">{!alertClassificationLoading ? Object.keys(alertClassificationData).length > 0 ? alertClassificationData.totalAlerts && alertClassificationData.totalAlerts : 0 : 0}</div>
                                        </div>
                                        <div style={{ borderRight: '1px solid #00539a' }}>
                                            <div className="card-title carbon-display-Regular-12">{DashboardConstants.DuplicateAlertsCount}</div>
                                            <div className="card-body">{!alertClassificationLoading ? Object.keys(alertClassificationData).length > 0 ? alertClassificationData.totalDuplicateAlerts && alertClassificationData.totalDuplicateAlerts : 0 : 0}</div>
                                        </div>
                                    </div>
                                    <div className="bx--col-lg-8 bx--col-md-4">
                                        <div style={{ marginBottom: '20px' }}>
                                            <div className="card-title carbon-display-Regular-12">{DashboardConstants.InformationalAlertsCount}</div>
                                            <div className="card-body">{!alertClassificationLoading ? informationalAlerts : 0}</div>
                                        </div>
                                        <div>
                                            <div className="card-title carbon-display-Regular-12">{DashboardConstants.TicketsCreatedCount}</div>
                                            <div className="card-body">{!alertClassificationLoading ? Object.keys(alertClassificationData).length > 0 ? alertClassificationData.uniqueAlerts && alertClassificationData.uniqueAlerts : 0 : 0}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> : DashboardConstants.NoDataAvailable}
            </div>,
        FirstTimeSuccessfulRun:
            <div>
                <div className="KPI-title">{DashboardConstants.FirstTimeRun}</div>
                {barChartLoading === true ? <div className="loading-container"> <InlineLoading description={DashboardConstants.loading} /> </div> :
                    firstTimeBarData.length > 0 ?
                        <div className="chart-wrapper">
                            <div className="chart-container">
                                <SimpleBarChart loading={barChartLoading} data={firstTimeBarData} options={options}> </SimpleBarChart>
                            </div>
                        </div> : DashboardConstants.NoDataAvailable}
            </div>,
        ExceptionClassification:
            <div>
                <div className="KPI-title">{DashboardConstants.ExceptionClassification}</div>
                {executionClassificationsLoading === true ? <div className="loading-container"> <InlineLoading description={DashboardConstants.loading} /> </div> :
                    <div className="chart-wrapper">
                        <div className="chart-container">
                            <DashboardDonutChart donutChartData={executionClassificationsData} loading={executionClassificationsLoading} />
                        </div>
                    </div>}
            </div>,
        LongRunningAutomataList:
            <div>
                <div className="KPI-title">{DashboardConstants.Top10LongRunningAutomatas}</div>
                {SchedulerExceptionLoading === true ? <div className="loading-container"> <InlineLoading description={DashboardConstants.loading} /> </div> :
                    <div className="chart-wrapper">
                        <div className="chart-container">
                            <DashboardGroupedBarChart loading={SchedulerExceptionLoading} groupedBarChartData={LongRunningAutomataData} graphAxesTitle={DashboardConstants.Count} graphBottomTitle="" />
                        </div>
                    </div>}
            </div>,
        TerminationReasons:
            <div>
                <div className="KPI-title">{DashboardConstants.RepeatedTerminationBots}</div>
                {RepeatedTerminationTableLoading === true ? <div className="loading-container"> <InlineLoading description={DashboardConstants.loading} /> </div> :
                    <div>
                        <div className="chart-container">
                            <DashboardTable loading={RepeatedTerminationTableLoading} rows={RepeatedTerminationBots} headers={RepeatedTerminationBotsHeaders} showPagination={true} isSortingAllowed={true} />
                        </div>
                    </div>}
            </div>,
        SchedulingEfficiency:
            <div>
                <div className="KPI-title">{DashboardConstants.SchedulingEfficiency}</div>
                <div className="chart-wrapper">
                    <div className="chart-container" style={{ marginTop: '70px' }}>
                        <div className="bx--row">
                            <div className="bx--col-lg-8 bx--col-md-4">
                                {SchedulerExceptionCountLoading === true ? <div className="loading-container"> <InlineLoading description={DashboardConstants.loading} /> </div> :
                                    <div style={{ borderRight: '1px solid #00539a', marginBottom: '20px' }}>
                                        <div className="card-title carbon-display-Regular-12">{DashboardConstants.NoOfSchedulerException}</div>
                                        <div className="card-body">{!SchedulerExceptionCountLoading && SchedulerExceptionCount}</div>
                                    </div>}
                            </div>
                            <div className="bx--col-lg-8 bx--col-md-4">
                                {SchedulerExceptionLoading === true ? <div className="loading-container"> <InlineLoading description={DashboardConstants.loading} /> </div> :
                                    <div style={{ marginBottom: '20px' }}>
                                        <div className="card-title carbon-display-Regular-12">{DashboardConstants.Top10LongRunningAutomatas}</div>
                                        <div className="card-body">{!SchedulerExceptionLoading && longRunningSummaryData}</div>
                                    </div>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>,
        QueueAverage: <div>
            <div className="KPI-title carbon-display-Regular-20">
                <div>{DashboardConstants.QueueAverageHandling}</div>
                {/* <div className="download-button">
                    <TableToolbarDownload iconDescription={DashboardConstants.Export} rows={queueformanceTableData} headers={queuePerformanceHeaders} title={DashboardConstants.QueuePerformance} filename={DashboardConstants.QueuePerformance} label={DashboardConstants.Download} />
                </div> */}
            </div>
            {QueueAverageLoading === true ? <div className="loading-container"> <InlineLoading description={DashboardConstants.loading} /> </div> :
                <div>
                    <div className="chart-container">
                        <DashboardTable loading={QueueAverageLoading} rows={QueueAverageData} headers={queueAverageHeaders} showPagination={true} isSortingAllowed={true} />

                    </div>
                </div>}
        </div>,
        LoginTrend: <div>
            <div className="KPI-title" >
                <div style={{ display: "flex" }}>
                    <div>{DashboardConstants.LoginTrend}</div>
                    <Tooltip direction="right">
                        <div style={{ color: "black", fontSize: "14px" }}>
                            {DashboardConstants.LineChartTooltip}
                        </div>
                    </Tooltip>
                </div>
            </div>
            {LoginTrendLoading === true ? <div className="loading-container"> <InlineLoading description={DashboardConstants.loading} /> </div> :
                LoginTrendData && LoginTrendData.length > 0 ?
                    <div className="chart-wrapper">
                        <div className="chart-container">
                            <DashboardLineChart hideDownloadButton={true} height="300px" lineGraphData={LoginTrendData} loading={LoginTrendLoading}
                                graphTitle={DashboardConstants.Count} modalTitle="" colors={SalesforceLineChartColors} />
                        </div>
                    </div> : DashboardConstants.NoDataAvailable}
        </div>,
        UserLoginTopFailures: <div>
            <div className="KPI-title">
                {DashboardConstants.UserLoginTopfailures}
            </div>
            {UserLoginTopFailuresLoading === true ? <div className="loading-container"> <InlineLoading description={DashboardConstants.loading} /> </div> :
                UserLoginTopFailuresData && UserLoginTopFailuresData.length > 0 ?
                    <div className="chart-wrapper">
                        <div className="chart-container">
                            <DashboardGroupedBarChart
                                loading={UserLoginTopFailuresLoading}
                                graphAxesTitle={DashboardConstants.Count}
                                graphBottomTitle={DashboardConstants.Category}
                                groupedBarChartData={UserLoginTopFailuresData}
                                hideDownloadButton={true}
                                height="300px"
                                toolbarEnabled={false}
                            />
                        </div>
                    </div> : DashboardConstants.NoDataAvailable}
        </div>,
        BatchJobsTrend: <div>
            <div className="KPI-title" >
                <div style={{ display: "flex" }}>
                    <div>{DashboardConstants.BatchJobTrend}</div>
                    <Tooltip direction="right">
                        <div style={{ color: "black", fontSize: "14px" }}>
                            {DashboardConstants.LineChartTooltip}
                        </div>
                    </Tooltip>
                </div>
            </div>
            {BatchJobsTrendLoading === true ? <div className="loading-container"> <InlineLoading description={DashboardConstants.loading} /> </div> :
                BatchJobsTrendData && BatchJobsTrendData.length > 0 ?
                    <div className="chart-wrapper">
                        <div className="chart-container">
                            <DashboardLineChart hideDownloadButton={true} height="300px" lineGraphData={BatchJobsTrendData} loading={BatchJobsTrendLoading}
                                graphTitle={DashboardConstants.Count} modalTitle="" colors={SalesforceLineChartColors} />
                        </div>
                    </div> : DashboardConstants.NoDataAvailable}
        </div>,
        BatchJobsTopFailures: <div>
            <div className="KPI-title">
                {DashboardConstants.BatchJobFailures}
            </div>
            {BatchJobsTopFailuresLoading === true ? <div className="loading-container"> <InlineLoading description={DashboardConstants.loading} /> </div> :
                BatchJobsTopFailuresData && BatchJobsTopFailuresData.length > 0 ?
                    <div className="chart-wrapper">
                        <div className="chart-container">
                            <DashboardGroupedBarChart
                                loading={BatchJobsTopFailuresLoading}
                                graphAxesTitle={DashboardConstants.Count}
                                graphBottomTitle={DashboardConstants.Category}
                                groupedBarChartData={BatchJobsTopFailuresData}
                                hideDownloadButton={true}
                                height="300px"
                                toolbarEnabled={false}
                            />
                        </div>
                    </div> : DashboardConstants.NoDataAvailable}
        </div>,
        IntegrationTrend: <div>
            <div className="KPI-title" >
                <div style={{ display: "flex" }}>
                    <div>{DashboardConstants.IntegrationTrend}</div>
                    <Tooltip direction="right">
                        <div style={{ color: "black", fontSize: "14px" }}>
                            {DashboardConstants.LineChartTooltip}
                        </div>
                    </Tooltip>
                </div>
            </div>
            {IntegrationTrendLoading === true ? <div className="loading-container"> <InlineLoading description={DashboardConstants.loading} /> </div> :
                IntegrationTrendData && IntegrationTrendData.length > 0 ?
                    <div className="chart-wrapper">
                        <div className="chart-container">
                            <DashboardLineChart hideDownloadButton={true} height="300px" lineGraphData={IntegrationTrendData} loading={IntegrationTrendLoading}
                                graphTitle={DashboardConstants.Count} modalTitle="" colors={SalesforceLineChartColors} />
                        </div>
                    </div> : DashboardConstants.NoDataAvailable}
        </div>,
        IntegrationTopFailures: <div>
            <div className="KPI-title">
                {DashboardConstants.IntegrationTopFailures}
            </div>
            {IntegrationTopFailuresLoading === true ? <div className="loading-container"> <InlineLoading description={DashboardConstants.loading} /> </div> :
                IntegrationTopFailuresData && IntegrationTopFailuresData.length > 0 ?
                    <div className="chart-wrapper">
                        <div className="chart-container">
                            <DashboardGroupedBarChart
                                loading={IntegrationTopFailuresLoading}
                                graphAxesTitle={DashboardConstants.Count}
                                graphBottomTitle={DashboardConstants.Category}
                                groupedBarChartData={IntegrationTopFailuresData}
                                hideDownloadButton={true}
                                height="300px"
                                toolbarEnabled={false}
                            />
                        </div>
                    </div> : DashboardConstants.NoDataAvailable}
        </div>,
        AbandonedProcessesTrend: <div>
            <div className="KPI-title" >
                <div style={{ display: "flex" }}>
                    <div>{DashboardConstants.AbandonedProcessesTrend}</div>
                    <Tooltip direction="right">
                        <div style={{ color: "black", fontSize: "14px" }}>
                            {DashboardConstants.LineChartTooltip}
                        </div>
                    </Tooltip>
                </div>
            </div>
            {AbandonedProcessesTrendLoading === true ? <div className="loading-container"> <InlineLoading description={DashboardConstants.loading} /> </div> :
                AbandonedProcessesTrendData && AbandonedProcessesTrendData.length > 0 ?
                    <div className="chart-wrapper">
                        <div className="chart-container">
                            <DashboardLineChart hideDownloadButton={true} height="300px" lineGraphData={AbandonedProcessesTrendData} loading={AbandonedProcessesTrendLoading}
                                graphTitle={DashboardConstants.Count} modalTitle="" colors={SalesforceLineChartColors} />
                        </div>
                    </div> : DashboardConstants.NoDataAvailable}
        </div>,
        AbandonedTopFailures: <div>
            <div className="KPI-title">
                {DashboardConstants.AbandonedProcessesFailures}
            </div>
            {AbandonedProcessesTopFailuresLoading === true ? <div className="loading-container"> <InlineLoading description={DashboardConstants.loading} /> </div> :
                AbandonedProcessesTopFailuresData && AbandonedProcessesTopFailuresData.length > 0 ?
                    <div className="chart-wrapper">
                        <div className="chart-container">
                            <DashboardGroupedBarChart
                                loading={AbandonedProcessesTopFailuresLoading}
                                graphAxesTitle={DashboardConstants.Count}
                                graphBottomTitle={DashboardConstants.Category}
                                groupedBarChartData={AbandonedProcessesTopFailuresData}
                                hideDownloadButton={true}
                                height="300px"
                                toolbarEnabled={false}
                            />
                        </div>
                    </div> : DashboardConstants.NoDataAvailable}
        </div>,
    };
    const classes = useStyles();
    return (
        <Card className={classes.root}>
            <div className={classes.header}>
                <Typography variant="h6" gutterBottom>
                    {widgetNames[id]}
                </Typography>
                <div className={classes.spacer} />
                {/* <IconButton aria-label="delete" onClick={() => onRemoveItem(id)} className={classes.deleteIcon}>
                    <CloseIcon fontSize="small" />
                </IconButton> */}
            </div>
            <div className={classes.body} />
        </Card>
    );
}
